import { ReduxState } from 'ducks';
import { getAttrByDateMap, DateAttributes } from 'lib/util/datePickerHelpers';
import { selectLimitedAvailabilityThreshold } from 'lib/util/privateMarketplace';
import { useSelector } from 'react-redux';

export const useAttrByDateMap = (): { [date: string]: DateAttributes } => {
  const limitedAvailabilityThreshold = useSelector(selectLimitedAvailabilityThreshold);
  const product = useSelector((state: ReduxState) => state.server.product.product);
  const productInstances = useSelector((state: ReduxState) => state.productInstances.all);

  return product
    ? getAttrByDateMap(productInstances, product.start_timezone, limitedAvailabilityThreshold)
    : {};
};
